var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-news"},[_c('img',{staticClass:"h-banner",attrs:{"src":require("@/assets/img/new.jpg")}}),_vm._l((_vm.newData),function(item){return _c('product-serie',{key:item.id,attrs:{"W":"","productData":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }